import React from 'react'

// VS monogram + wordmark, recreated from vs-landing/components/Logo.tsx (dark-surface
// variant). Don't use images/vestirstudio_logo.png — it is a "Stratega Studio" logo.
export const BrandMark = () => (
  <div className="flex items-center gap-2.5 px-2 py-1">
    <img src="/icon.svg" alt="" width="32" height="32" className="block h-8 w-8 rounded-[7px]" />
    <div className="flex flex-col leading-[1.1]">
      <span aria-label="VestirStudio" className="font-brand text-lg font-medium tracking-[-0.01em] text-[#F8F4EE]">
        Vestir<em className="italic text-[#a87640]">Studio</em>
      </span>
      <span className="text-[11px] font-medium uppercase tracking-[0.08em] text-admin-400">Admin</span>
    </div>
  </div>
)
